import { handleClickTestBtn } from './handle/handleClickTestBtn.js';
import refsEl from '../refs.js';

const refs = refsEl();

// вешаем слушателя на кнопку открывающую модальное окно с формой.
export const firebase = () => {};
refs.btnTestEl.addEventListener('click', handleClickTestBtn);
